<template>
  <div>
    <v-dialog
      v-model="r_prop"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
      max-width="550px"
    >
      <v-card class="rounded_max">
        <v-toolbar dense flat>
          <h3>{{ title }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 py-0" v-if="inventory">
          <v-container style="height: max-content" v-if="inventory.data">
            <h4>Proposal Title</h4>
            <div class="temp_txt pa-2">
              <p class="mb-0">{{ inventory.body.title }}</p>
            </div>
            <h4>Status</h4>
            <div class="temp_txt pa-2">
              <p class="mb-0">{{ inventory.data.aproval }}</p>
            </div>
            <h4>Notes :</h4>
            <div class="temp_txt pa-2">
              <p class="mb-0">{{ inventory.data.notes }}</p>
            </div>
            <div class="mt-2">
              <h4>Description of Proposal</h4>
              <v-textarea
                class="mb-2"
                auto-grow
                outlined
                color="green"
                rows="4"
                placeholder="Put Description for Proposal"
                v-model="inventory.body.description"
                hide-details
                dense
              ></v-textarea>
            </div>
            <!-- <div class="mt-2">
              <h4>Additional Link</h4>
              <v-textarea
                class="mb-2"
                auto-grow
                outlined
                color="green"
                rows="4"
                placeholder="Put Link for Proposal"
                v-model="inventory.body.content"
                hide-details
                dense
              ></v-textarea>
            </div> -->
            <!-- ======================================================================SPONSORSHIP -->
            <v-card
              class="pa-2 mb-3 rounded-lg"
              outlined
              v-for="(item, i) in inventory.form"
              :key="i"
            >
              <div class="d-flex align-start mb-2">
                <v-icon color="var(--g)">mdi-circle-medium</v-icon>
                <p class="mb-0 text-justify">
                  {{ item.title }}
                </p>
              </div>
              <a :href="inventory.body[item.key2]" v-if="!item.edit">
                {{ inventory.body[item.key2] }}
              </a>
              <div v-if="item.edit">
                <p class="default_txt">Type</p>
                <v-select
                  class="mb-2 rounded-lg"
                  dense
                  outlined
                  :items="itemType"
                  v-model="inventory.field[item.key1]"
                  @change="resetVal(item.key2)"
                  label="Type"
                  color="green"
                  flat
                  hide-details
                  solo
                  style="width: 30%"
                ></v-select>
                <p class="default_txt">Content</p>
                <v-textarea
                  v-if="inventory.field[item.key1] == 'embed'"
                  class="rounded-lg"
                  auto-grow
                  color="green"
                  outlined
                  rows="2"
                  placeholder="Put the link here"
                  v-model="inventory.field[item.key2]"
                  hide-details
                  dense
                ></v-textarea>
                <v-file-input
                  v-if="inventory.field[item.key1] == 'upload'"
                  class="rounded-lg"
                  color="green"
                  v-model="inventory.field[item.key2]"
                  placeholder="Select file"
                  accept="image/jpeg, application/pdf"
                  outlined
                  dense
                ></v-file-input>
              </div>
              <div class="d-flex justify-end mt-2">
                <v-btn
                  v-if="!item.edit"
                  depressed
                  dark
                  color="var(--g)"
                  @click="item.edit = true"
                  >edit</v-btn
                >
                <v-btn
                  v-if="item.edit"
                  depressed
                  dark
                  color="var(--g)"
                  @click="item.edit = false"
                  >cancel</v-btn
                >
              </div>
            </v-card>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="$emit('close')">
            Close
          </v-btn>
          <v-btn color="green darken-1" text @click="updateData"> Save </v-btn>
        </v-card-actions>
        <v-overlay :absolute="true" color="white" opacity="1" :value="loading">
          <v-progress-circular
            indeterminate
            class="mr-2"
            color="#006341"
          ></v-progress-circular>
          <b class="color_default">Loading...</b>
        </v-overlay>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "reviewProposal",
  props: ["r_prop", "inventory", "title"],
  computed: {},
  data() {
    return {
      loading: false,
      itemType: ["embed", "upload"],
    };
  },
  methods: {
    resetVal(key) {
      this.inventory.field[key] = null;
    },
    updateData() {
      this.loading = true;

      let body = new FormData();
      body.append("id", this.inventory.body.id);
      body.append("description", this.inventory.body.description);
      if (this.inventory.field) {
        for (let i in this.inventory.field) {
          if (i.includes("type_")) {
            let piece = i.replace("type_", "");
            if (this.inventory.field[`attach_${piece}`] != null) {
              body.append(i, this.inventory.field[`type_${piece}`]);
              body.append(
                `attach_${piece}`,
                this.inventory.field[`attach_${piece}`],
              );
            } else {
              body.append(i, this.inventory.field[`type_${piece}`]);
              for (let k in this.inventory.body) {
                if (k == `attach_${piece}`) {
                  body.append(k, this.inventory.body[k]);
                }
              }
            }
          }
        }
      }

      let data = {
        path: this.inventory.path,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$emit("close");
          this.$emit("refetch");
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.input_hide {
  display: none;
}
.title_f {
  border: solid 1px #cccccc;
  width: 100%;
  border-radius: 8px;
  /* height: 35px; */
  padding: 8px 10px;
  margin-bottom: 10px;
}
.title_f:focus {
  outline: none;
}
.temp_txt {
  background: #f6f6f6;
  border-radius: 5px;
}
</style>
